import { CircleIconProps } from './CircleIcon.types';
import CircleIcon from './CircleIcon';

export default CircleIcon;
export { CircleIconProps, CircleIcon };
